import React, { useState, useRef, useEffect } from "react";
import DOMPurify from "dompurify";

export default function HTMLContents({ data }) {
  const [showFull, setShowFull] = useState(false);
  const [shouldShowToggle, setShouldShowToggle] = useState(false);

  const contentRef = useRef(null);

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const decodedData = DOMPurify.sanitize(decodeHtml(data || ""));

  useEffect(() => {
    if (contentRef.current) {
      setShouldShowToggle(
        contentRef.current.scrollHeight > contentRef.current.clientHeight
      );
    }
  }, [decodedData]);

  return (
    <>
      <style>{`
        .html-content,
        .html-content p {
          color: #686868 !important;
          text-decoration: none !important;
        }

        .truncate {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .view-toggle {
          color: #007bff;
          cursor: pointer;
          font-weight: 500;
          margin-top: 5px;
          display: inline-block;
        }
      `}</style>

      {data && (
        <>
          <div
            ref={contentRef}
            className={`html-content ${!showFull ? "truncate" : ""}`}
            dangerouslySetInnerHTML={{ __html: decodedData }}
          />

          {shouldShowToggle && (
            <span
              className="view-toggle"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowFull((prev) => !prev);
              }}
            >
              {showFull ? "Read Less" : "Read More"}
            </span>
          )}
        </>
      )}
    </>
  );
}